import type { Href, ImperativeRouter } from 'expo-router'

/** Pop the actual navigation origin, with a deterministic deep-link fallback. */
export function goBackOr(router: ImperativeRouter, fallback: Href): void {
  if (router.canGoBack()) router.back()
  else router.replace(fallback)
}

/**
 * Navigate back if there is a screen to pop, otherwise replace to home.
 *
 * Plain `router.back()` warns "GO_BACK was not handled by any navigator"
 * when called on a screen with no history — common on web after a refresh
 * or when landing on a deep link. Falling back to `router.replace('/')`
 * gives the user a deterministic exit either way.
 */
export function goBackOrHome(router: ImperativeRouter): void {
  goBackOr(router, '/')
}
